export const MAX_LOOKBACK_DAYS_DAILY = 20 * 365;
export const MAX_LOOKBACK_DAYS_COMPARE_DAILY = 20 * 365;

export const MAX_LOOKBACK_DAYS_HOURLY = 8;
export const MAX_LOOKBACK_DAYS_COMPARE_HOURLY = 15;
